import React, { FormEvent } from 'react';

import { EVENT_TYPE_DISMISS, EVENT_TYPE_SSO_INIT, EVENT_TYPE_SUBMIT } from './index';

export const handleSubmitEvent = (formEvent: FormEvent) => {
  formEvent.preventDefault();
};

export const handleClickEventOfNonType = (event: React.MouseEvent<Element, MouseEvent>) => {
  const target = event.target as HTMLElement;
  const targetType = target.getAttribute('type');
  if (
    targetType &&
    (EVENT_TYPE_SUBMIT === targetType.toUpperCase() ||
      targetType.toUpperCase().endsWith(EVENT_TYPE_SSO_INIT))
  ) {
    // form submit
    event.preventDefault();
    return targetType.toUpperCase();
  }

  // dismiss
  const dismisses = document.querySelectorAll(`[data-xstate-event="${EVENT_TYPE_DISMISS}"]`);
  if ([...dismisses].some((element: Element) => element.contains(target))) {
    return EVENT_TYPE_DISMISS;
  }

  return null;
};
